"use client";

import React, { useState } from 'react';
import Container from './components/Container';
import { Text } from '@radix-ui/themes';
import { Button } from './components/ui/button';
import { AnimatePresence, motion } from 'framer-motion';
import AuctionForm from './admin/auctions/new/AuctionForm';
import { useRouter } from 'next/navigation';

const NewAdminPage = () => {
  const [showForm, setShowForm] = useState(false);
  const router = useRouter();

  return (
    <Container className="pt-6">
      <AnimatePresence mode="wait">
        {showForm ? (
          <motion.div
            key="auction-form"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
          >
            <AuctionForm
                onCancel={() => setShowForm(false)}
                onCreated={(auction) => {
                    router.push(`/admin/auctions/${auction.id}/settings`)
                }}
            />
          </motion.div>
        ) : (
          <motion.div
            key="welcome"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
          >
            <div className="mt-2">
              <Text className="text-2xl font-semibold pb-6">Welcome to Biddify!</Text>
              <p className="pb-6">To get started, please create an auction.</p>
              <Button onClick={() => setShowForm(true)}>Create Auction</Button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </Container>
  )
}

export default NewAdminPage